import React from 'react';
import { Alert } from 'react-bootstrap';
import { Redirect } from 'react-router';
import { isEmpty } from 'lodash';

import tvtApi from '../../services/tvt-api';

import ResetPasswordForm from './ResetPasswordForm';

import './ResetPassword.css';

export const USER_REQUIRED = 'Username is required.';
export const PASS_REQUIRED = 'Password is required.';
export const PASS2_REQUIRED = 'Password confirmation is required.';
export const MATCH_PASS_REQUIRED = 'Passwords must match.';

export default class ResetPassword extends React.Component {
  state = {
    loading: false,
    goToLogin: false
  };

  validate = ({ username, password, password2 }) => {
    let password2Validation;

    if (isEmpty(password2)) password2Validation = PASS2_REQUIRED;
    else {
      password2Validation =
        !isEmpty(password) && password !== password2
          ? MATCH_PASS_REQUIRED
          : null;
    }

    return {
      username: isEmpty(username) ? USER_REQUIRED : null,
      password: isEmpty(password) ? PASS_REQUIRED : null,
      password2: password2Validation
    };
  };

  submit = async ({ username, password }) => {
    try {
      const {
        match: {
          params: { hash }
        }
      } = this.props;

      this.setState({ loading: true });
      const { data } = await tvtApi.resetPassword(hash, username, password);
      if (data) {
        return this.setState({ success: true });
      }
    } catch (error) {
      console.log(error);
    }

    this.setState({ goToLogin: true });
    return null;
  };

  render() {
    if (this.state.goToLogin) {
      return <Redirect to="/login" />;
    }

    if (this.state.success) {
      return (
        <div className="tvt-reset-password">
          <Alert bsStyle="success">
            <h4>Success!</h4>
            <p>Now you can login with your new password.</p>
          </Alert>
          <span
            role="presentation"
            className="tvt-reset-password__back"
            onClick={() => this.setState({ goToLogin: true })}
          >
            Back to login page
          </span>
        </div>
      );
    }

    return (
      <div className="tvt-reset-password">
        <h1 className="tvt-reset-password__header">Reset Your Password</h1>
        <ResetPasswordForm
          loading={this.state.loading}
          onSubmit={this.submit}
          validate={this.validate}
        />
      </div>
    );
  }
}
